module.exports = __webpack_public_path__ + "img/liyang.4f5ba6af.jpg";